export default {"src":"/_next/static/media/404-illustration-dark.aa254e2a.svg","height":176,"width":176,"blurWidth":0,"blurHeight":0};